export default __webpack_public_path__ + "static/alcohollamp-1e4f283ffe099ec1fad98e824d4937ab.png";